<div class="relative">
  <button
    class="text-purple-600 hover:text-purple-800 hover:scale-110 transition-transform cursor-pointer"
    type="button"
    (click)="isOpen = true"
    appAgentAction
    agent="import-nw-number-popover-open"
    businessObject="nwNumber"
    [businessId]="$safeNavigationMigration(nwNumber?.id)"
    action="open"
  >
    <app-import-icon></app-import-icon>
  </button>
  <div
    role="tooltip"
    class="absolute z-10 right-4 top-6 inline-block text-sm text-gray-500 transition-opacity duration-300 bg-white border border-gray-200 rounded-lg shadow-md w-72"
    [class.invisible]="!isOpen"
    [class.opacity-0]="!isOpen"
  >
    <div class="p-3 space-y-2">
      <div class="flex justify-between">
        <h3 class="font-bold text-gray-800">Import</h3>
        <app-close-icon
          class="cursor-pointer hover:scale-110 transition-transform"
          (click)="isOpen = false"
          appAgentAction
          agent="import-nw-number-popover-close"
          businessObject="nwNumber"
          [businessId]="$safeNavigationMigration(nwNumber?.id)"
          action="close"
        ></app-close-icon>
      </div>
      <button
        *appIfPolicySatisfied="policy.canImport"
        (click)="importClicked.emit({ nwNumber: nwNumber!, importType: importType.ImportErrorCodes }); isOpen = false"
        type="button"
        class="text-teal-400 disabled:text-gray-400 hover:text-teal-600 cursor-pointer hover:scale-105 hover:bg-orange-100 p-0.5 rounded-md"
        appAgentAction
        agent="import-nw-number-popover-import-error-codes"
        businessObject="nwNumber"
        [businessId]="$safeNavigationMigration(nwNumber?.id)"
        action="import"
      >
        <div class="flex items-start gap-x-4">
          <app-import-icon class="font-medium"></app-import-icon>
          <p class="text-xs text-gray-500 text-start">Import Error Codes</p>
        </div>
      </button>
      <div class="flex items-start gap-x-3">
        <button
          *appIfPolicySatisfied="policy.canImport"
          (click)="
            importClicked.emit({ nwNumber: nwNumber!, importType: importType.ImportTrDocumentation }); isOpen = false
          "
          type="button"
          class="text-indigo-500 disabled:text-gray-400 disabled:cursor-not-allowed hover:text-indigo-700 cursor-pointer hover:scale-105 hover:bg-orange-100 p-0.5 rounded-md"
          appAgentAction
          agent="import-nw-number-popover-import-tr-documentation"
          businessObject="nwNumber"
          [businessId]="$safeNavigationMigration(nwNumber?.id)"
          action="import"
        >
          <div class="flex items-start gap-x-4">
            <div class="relative font-medium">
              <app-import-icon class="font-medium"></app-import-icon>
              <span class="text-[8px] absolute top-4 -end-1">DOC</span>
            </div>
            <p class="text-xs text-gray-500 text-start">Import documentation from TR</p>
          </div>
        </button>
      </div>
    </div>
  </div>
</div>
